var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function QueueMessagesWS() {
  var self; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;

  self.allLanguages = ko.observableArray([]);
  self.allLanguageNames = ko.observableArray([]);
  self.bundle = ko.observable(null);
  self.bundles = [];
  self.json = null;
  self.localesParam = ko.observable('');
  self.name = 'QueueMessagesWS';				// Convenience name for debugging
  self.phoneMask = ko.observable(null);


  /**
  * This computed observable returns the URL of the service endpoint
  *
  * @method serviceURL
  * @returns {String}
  */
  self.serviceURL = ko.computed(function () {
    return '';
  });


  /**
  * This computed observable returns the locale of the currently selected bundle
  *
  * @method activeLocale
  * @returns {String|Null} The locale token of the current bundle
  */
  self.activeLocale = ko.computed(function () {
    if (self.bundle() != null) {
      return self.bundle().locale;
    }
    return null;
  });


  /**
  * Override of abstract method. Allows for the URL to be created at runtime
  *
  * @method doRequest
  * @param {Function} fCallback
  * @returns none
  */
  self.doRequest = function (fCallback, queueId) {
    if (vm.selectedLocationIds().length > 0) {
      var langs = vm.selectedLocationIds().reduce(function (arr, id) {
        var loc = vm.locationsWS.getLocationById(id);

        if (loc && Array.isArray(loc)) {
          loc.language.forEach(function (lang) {
            if (!arr.includes(lang)) {
              arr.push(lang);
            }
          });
        }

        return arr;
      }, []);

      var endPoint = '/qless/api/v1/messages/merchant/queue/' + queueId;

      if (langs.length > 0) {
        endPoint += '?locale=' + langs.join(',');
      }
      else {
        endPoint += '?locale=' + vm.userLang();
      }
    }

    if (endPoint) {
      // Generate a new Service URL
      self.serviceURL = ko.computed(function () {
        return endPoint;
      });

      AbstractWS.prototype.doRequest.call(self, fCallback);
    }
  };


  /**
  * Method to retrieve text value of the provided key from the current bundle
  *
  * @method get
  * @param {String} key Token to use to find the text value from the bundle
  * @param {Boolean} doStripHtml Unless passed as false, HTML entities will be removed
  * @param {Array} aTokens Array of token replacement strings
  * @returns {String}
  */
  self.get = function (key, doStripHtml, locale) {
    var bundleForLocale = self.bundle();
    var emptyMessage = '';

    if (locale) {
      self.bundles.forEach(function (bundle) {
        if (bundle.locale.toLowerCase() == locale.toLowerCase()) {
          bundleForLocale = bundle;
        }
      });
    }

    // If there is a bundle, else return an empty string
    if (bundleForLocale) {

      var bundleMessages = bundleForLocale.m;

      // Get the first message from the bundle that matches
      var messageFromBundle = bundleMessages.find(function (message) {
        return (message.n == key && (message.text !== undefined || message.text !== null))
      })

      if (!messageFromBundle) {
        return emptyMessage;
      }

      var stripHtmlFromMessage = function(text) {
        return (text)
          ? String(text).replace(/(<([^>]+)>)/ig, '')
          : text
      }

      var fillTokensInMessage = function (message) {
        // resolve token placeholders in bundle with actual values
        var tokens = message && String(message).match(/{[0-9a-zA-Z\.]+}/g);

        var replaceTokensWithValues = function (text, currentToken) {
          var strippedToken = currentToken.replace(/\{|\}/g, "")
          var replacement = self.get(strippedToken)

          return replacement
            ? text.replace(currentToken, replacement)
            : text
        };

        var filledMessage = (tokens)
          ? tokens.reduce(replaceTokensWithValues,message)
          : message;

        return filledMessage;
      }

      var overriddenMessage = (doStripHtml)
        ? fillTokensInMessage(stripHtmlFromMessage(messageFromBundle.text))
        : fillTokensInMessage(messageFromBundle.text)

      return overriddenMessage;
    }
  }

  /**
  * Sets the current bundle to the specified language string. If the language
  * string was not found, try to load the defaultLocale bundle. If a bundle
  * could still not be found, just load the first language bundle instead.
  *
  * @method setLocale
  * @param {String} sLang language locale to find a bundle of
  * @returns {QueueMessagesWS} Returns the object as chainable, for best practice
  */
  self.setLocale = function (sLang) {
    var bundle = null,		// Instance of a message bundle
      hasBundle = false,		// Whether a matching bundle was found
      i = 0;				// Standard increment

    // If the language locale was not specified, don't bother
    if (sLang == null) {
      return;
    }

    // Start by trying to set the bundle to the requested bundle
    self.bundles.forEach(function (bundle) {
      var langParts = sLang.toLowerCase().split('_');
      var bundleParts = bundle.locale.toLowerCase().split('_');

      if (bundle.locale.toLowerCase() == sLang.toLowerCase()) {
        hasBundle = true;
        self.bundle(bundle);
      }
      else if (!hasBundle && langParts[0] == bundleParts[0]) {
        hasBundle = true;
        self.bundle(bundle);
      }
    });

    // If the requested bundle could not be found and the default language
    // bundle could not be found (accounting for logic error in the VM
    // defaultLocale() function), just set the bundle to the first bundle
    if (!hasBundle) {
      self.bundle(self.bundles[0]);
    }

    // Return self (QueueMessagesWS) to be chainable, for best practice
    return self;
  };


  /**
  * This method processes the data returned from the service
  *
  * @method processData
  * @param {XMLString} xmlData XML data returned from the service
  * @returns {QueueMessagesWS} Returns the object as chainable, for best practice
  */
  self.processData = function (xmlData) {
    var locale = 'en';

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);
    var json = xmlToJson.parse(xmlData);


    if (!Array.isArray(json.bundles.bundle)) {
      self.bundles = [json.bundles.bundle];
    }
    else {
      self.bundles = json.bundles.bundle;
    }

    // Sets the initial bundle
    self.bundles.forEach(function (bundle) {
      if (vm.userLang && vm.userLang() && vm.userLang().toLowerCase() === bundle.locale.toLowerCase()) {
        locale = bundle.locale;
      }
    });

    self.setLocale(locale);

    // Set the phoneMask
    self.phoneMask(self.get('phone.mask') || null);

    // Return self (QueueMessagesWS) to be chainable, for best practice
    return self;

  };

  // Return self (QueueMessagesWS)
  return self;
};


QueueMessagesWS.prototype = AbstractWS.prototype;
QueueMessagesWS.prototype.constructor = AbstractWS;

module.exports = QueueMessagesWS;
